<template>
  <div class="OrderDeta">

    <div class="overflow" ref="overflow" >

      <div class="main">

        <ul class="list_ul">
          <li>
<!--            <p class="list_name">{{ deta.productCategory }}</p>-->
            <p v-if="deta.productCategory == 0" class="list_name">体检套餐</p>
            <p v-if="deta.productCategory == 1" class="list_name">胃肠镜筛查</p>
            <p v-if="deta.productCategory == 2" class="list_name">整合式筛查</p>
            <p v-if="deta.productCategory == 3" class="list_name">锦医未</p>
            <div class="list_li_deta" @click="link_Deta()">
              <img :src="deta.thumbnail" alt="">
              <div class="list_item">
                <h2>{{ deta.productName }}</h2>
                <p class="list_item_p1">{{ deta.subhead }}</p>
<!--                <p class="list_item_p2">¥ {{ deta.productPrice }}</p>-->
                <p class="list_item_p2">{{ deta.productPrice != 0 ? "¥" + deta.productPrice : "卡支付" }}</p>
              </div>
            </div>
          </li>
        </ul>

        <div class="main_content">

          <div class="main_content_info">
            <div class="list_left">
              <p class="list_left_top">就诊人</p>
              <h2>{{ deta.name }}</h2>
              <p class="list_left_gender" v-if="deta.gender == 0" >女</p>
              <p class="list_left_gender" v-if="deta.gender == 1" >男</p>
            </div>
            <div class="list_right">
              <div class="list_right_li" v-if="deta.relationshipValue != 0">
                <span>
                  <p>与</p>
                  <p>本</p>
                  <p>人</p>
                  <p>关</p>
                  <p>系</p>
                </span>
                <p class="list_right_li_p">{{ deta.relationshipValue }}</p>
              </div>
              <mu-badge v-if="deta.relationshipValue == 0" content="本人" color="primary"></mu-badge>
              <div class="list_right_li">
            <span>
              <p>手</p>
              <p>机</p>
              <p>号</p>
            </span>
                <p class="list_right_li_p">{{ deta.phoneNo }}</p>
              </div>
              <div class="list_right_li">
            <span>
              <p>身</p>
              <p>份</p>
              <p>证</p>
              <p>号</p>
            </span>
                <p class="list_right_li_p">{{ deta.idCardNo }}</p>
              </div>
            </div>
          </div>

          <template v-if="deta.appointments.length != 0">
            <ul class="commodity">
              <li class="commodity_li" v-for="item in deta.appointments" :key="item.id">
                <div class="commodity_li_header">
<!--                  <p>{{ item.productCategory }}</p>-->
                  <p v-if="item.productCategory == 0">体检套餐</p>
                  <p v-if="item.productCategory == 1">胃肠镜筛查</p>
                  <p v-if="item.productCategory == 2">整合式筛查</p>
                  <p v-if="item.productCategory == 3">锦医未</p>

                  <p v-if="item.status == 0" class="warning">待确认</p>
                  <p v-if="item.status == 1" class="primary">待检查</p>
                  <p v-if="item.status == 2" class="success">已完成</p>
                  <p v-if="item.status == 3" class="danger">已失效</p>
                </div>
                <ul class="commodity_li_ul">
                  <li>
                    <span>预约时间</span>
<!--                    <p>{{ item.appointmentDate }} {{ item.appointmentTime }}</p>-->
                    <p>{{ item.appointmentDate ? item.appointmentDate : item.appointmentStartDate + '至' + item.appointmentEndDate }}
                      <br/>
                      {{ item.appointmentTime }}</p>
                  </li>
                  <li>
                    <span>预约地点</span>
                    <p>{{ item.hospitalName }}（{{ item.address }}）</p>
                  </li>
                </ul>
                <div class="button" v-if="item.productCategory == 1">
                  <mu-button @click="link_plan(item.id)" color="success">胃肠道准备</mu-button>
                </div>
              </li>
            </ul>
          </template>


          <template v-if="deta.orderItemList && deta.orderItemList.length != 0">
            <ul class="orderItem">
              <li v-for="(item,index) in deta.orderItemList" :key="index" >
                <p>{{ item.itemName }}</p>
                <p>{{ "￥" + item.itemPrice }}</p>
              </li>
            </ul>
          </template>

          <p v-if="deta.appointments.length != 0" class="created_time">创建时间：{{ deta.appointments[0].createTime }}</p>

        </div>


      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "MakeDeta",
  data() {
    return{
      deta: {
        appointments: []
      }
    }
  },
  created() {
    this.get_deta(this.$route.query.id);
  },
  mounted() {

  },
  methods: {
    get_deta(y) {
      this.$get("appointment",y,true)
        .then(res => {
          if(res) {
            console.log(res.data);
            this.deta= res.data;
          }
        })
    },
    // 跳转产品详情
    link_Deta() {
      this.$router.push({
        path: "/Deta",
        query: {
          id: this.deta.productId
        }
      })
    },
    link_plan(e) {
      this.$router.push({
        path: "/StomachPlan",
        query: {
          id: e
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
    @import "../../../style/My/Order/OrderDeta";
</style>
